import ModalPortal from './ModalPortal';

export { type Props as ModalProps } from './Modal';

export default ModalPortal;
